import Enum from "./Enum";

export default Enum.create( {
	MANAGER: "MANAGER",
	REPORT: "REPORT",
	PEER: "PEER",
} );
